<template>
  <div>
    <a-card class="customer-filter">
      <service-filter-form ref="filterFormRef" v-model="filterForm" :service-strategys="serviceStrategys" @change="onFilter" @reset="onReset" />
    </a-card>
    <a-card title="服务列表" size="small" class="filter-data">
      <span slot="extra">
        <a-space>
          <a-button v-has="{ code: 'system:service:edit', project: 0 }" type="primary" @click="onBatchEdit"> 批量编辑 </a-button>
          <a-button v-has="{ code: 'system:service:delete', project: 0 }" type="danger" @click="onBatchDelete"> 批量删除 </a-button>
          <a-button v-has="{ code: 'system:service:add', project: 0 }" type="primary" icon="plus" @click="onAdd">添加</a-button>
        </a-space>
      </span>
      <service-data-list ref="serviceDataListRef" :service-strategys="serviceStrategys" @edit="onEdit" />
    </a-card>
    <service-drawer ref="serviceDrawerRef" @ok="onFilter" />
    <service-batch-edit ref="serviceBatchEditRef" :service-strategys="serviceStrategys" @ok="onFilter" />
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { serviceSpecialTests } from '@/utils/dictionary';
import { serviceBatchDelete } from '@/api/system/service';

import ServiceDrawer from '@/pages/system/components/ServiceDrawer';
import ServiceDataList from '@/pages/system/components/ServiceDataList';
import ServiceBatchEdit from '@/pages/system/components/ServiceBatchEdit';
import ServiceFilterForm from '@/pages/system/components/ServiceFilterForm';

export default {
  components: { ServiceDrawer, ServiceDataList, ServiceBatchEdit, ServiceFilterForm },
  data() {
    return {
      serviceSpecialTests,
      filterForm: {},
      loading: false,
      tableData: [],
      serviceStrategys: {}
    };
  },
  mounted() {
    this.getTagData();
    this.onFilter();
  },
  methods: {
    /**
     * 筛选数据事件
     */
    onFilter() {
      this.$nextTick(() => {
        this.$refs.serviceDataListRef.setFilter(this.filterForm);
      });
    },

    /**
     * 获取发布策略
     */
    getTagData() {
      tagList({ group_code: 'release_strategy' }).then(res => {
        const tags = {};
        res.data.items.forEach(item => {
          tags[item.name] = item;
        });
        this.serviceStrategys = tags;
      });
    },

    // 点击添加
    onAdd() {
      this.$nextTick(() => {
        this.$refs.serviceDrawerRef.onOpen();
      });
    },

    // 点击编辑
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs.serviceDrawerRef.onOpen(record.service_id);
      });
    },

    // 点击重置
    onReset() {
      this.filterForm = {};
      this.onFilter();
    },

    /**
     * 批量删除
     */
    onBatchDelete() {
      this.$nextTick(() => {
        const service_ids = this.$refs.serviceDataListRef.selectedRowKeys;
        if (service_ids.length === 0) {
          this.$message.warning('请先选择需要删除的服务');
          return;
        }
        const self = this;
        this.$confirm({
          title: '确认',
          content: `确认要删除这${service_ids.length}个服务吗`,
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            serviceBatchDelete({ service_ids: service_ids }).then(() => {
              self.$message.success('删除成功');
              self.onFilter();
            });
          }
        });
      });
    },

    /**
     * 批量修改
     */
    onBatchEdit() {
      this.$nextTick(() => {
        const service_ids = this.$refs.serviceDataListRef.selectedRowKeys;
        if (service_ids.length === 0) {
          this.$message.warning('请先选择需要编辑的服务');
          return;
        }
        this.$refs.serviceBatchEditRef.onOpen(service_ids);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.customer-filter {
  margin-bottom: 16px;
}
</style>
